import productApi from "./product";
import dashboardApi from "./dashboard";
import orderApi from "./order";
import brandApi from "./brand";
import merchentApi from "./merchant";
import userApi from "./users";
import authenticateApi from "./authenticate";
import topupApi from "./topup";
import reportApi from "./reports";
import logApi from "./logs";
import uploadApi from "./upload";
import customerinfoApi from "./customerinfo";
import resellertypeApi from "./resellertype";
import devcoApi from "./devco";
import stockApi from "./stock";

export function apiFactory() {
  return {
    products: productApi(),
    dashboard: dashboardApi(),
    orders: orderApi(),
    brands: brandApi(),
    merchants: merchentApi(),
    users: userApi(),
    authenticate: authenticateApi(),
    topup: topupApi(),
    reports: reportApi(),
    logs: logApi(),
    upload: uploadApi(),
    customerInfo: customerinfoApi(),
    resellerType: resellertypeApi(),
    devco: devcoApi(),
    stock: stockApi(),
  };
}

export const api = apiFactory();
